import React from 'react';

const ErrorMessage = ({ type, message }) => {
    return (
        <div className={`p-5 m-5 rounded-md ${type === 'error' ? 'bg-red-500 text-white' : 'bg-green-500 text-white'}`}>
            {message}
        </div>
    );
};

export default ErrorMessage;
